import { Link } from "react-router-dom";
import { categories } from "@/mocks/movies";

export default function CategoryTabs() {
  const displayCategories = categories.filter((c) => c.slug !== "all");

  return (
    <section className="px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-screen-2xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            浏览分类
          </h2>
          <Link
            to="/category/all"
            className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line ml-1 text-xs"></i>
          </Link>
        </div>
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-9 gap-3">
          {displayCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-2 p-4 rounded-lg bg-background-50 hover:bg-accent-100/70 border border-background-200/70 hover:border-accent-300 transition-all group cursor-pointer"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-white transition-colors">
                <i className={`${cat.icon} text-lg md:text-xl`}></i>
              </div>
              <span className="text-xs font-medium text-foreground-700 group-hover:text-accent-700 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}